import * as tslib_1 from "tslib";
import { OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { cache } from '../cache';
import { OSService } from '../shared/os.service';
var FeaturesComponent = /** @class */ (function () {
    function FeaturesComponent(osService) {
        this.osService = osService;
        this.osType = new BehaviorSubject(this.osService.os);
    }
    Object.defineProperty(FeaturesComponent.prototype, "reformatKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return '⌘⌥L';
                case 'win': return 'Ctrl+Alt+L';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "expandSelectionKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return '⌥↑';
                case 'win': return 'Ctrl+W';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "shrinkSelectionKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return '⌥↓';
                case 'win': return 'Ctrl+Shift+W';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "blockCommentKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return '⌃⇧/';
                case 'win': return 'Ctrl+Shift+/';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "lineCommentKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return '⌘/';
                case 'win': return 'Ctrl+/';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "parameterHintKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return '⌘P';
                case 'win': return 'Ctrl+P';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "typeInfoKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return '⌃⇧P';
                case 'win': return 'Ctrl+Shift+P';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "quickDocsKeys", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return 'F1';
                case 'win': return 'Ctrl+Q';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FeaturesComponent.prototype, "platform", {
        get: function () {
            switch (this.osType.value) {
                case 'mac': return 'Mac OS X 10.5+ Default';
                case 'win': return 'Windows / Linux Default';
                default: throw Error('Unexpected os: ' + this.osType.value);
            }
        },
        enumerable: true,
        configurable: true
    });
    FeaturesComponent.prototype.ngOnInit = function () {
    };
    FeaturesComponent.prototype.ngOnDestroy = function () {
        this.osType.complete();
    };
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "reformatKeys", null);
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "expandSelectionKeys", null);
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "shrinkSelectionKeys", null);
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "blockCommentKeys", null);
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "lineCommentKeys", null);
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "parameterHintKeys", null);
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "typeInfoKeys", null);
    tslib_1.__decorate([
        cache('osType'),
        tslib_1.__metadata("design:type", String),
        tslib_1.__metadata("design:paramtypes", [])
    ], FeaturesComponent.prototype, "quickDocsKeys", null);
    return FeaturesComponent;
}());
export { FeaturesComponent };
